// Review Types

export interface CreateReviewDto {
  orderId?: string;
  token?: string;
  rating: number;
  reviewerName: string;
  comment?: string;
  email?: string;
  highlights?: string[];
  wouldOrderAgain?: string;
  agreeToPublish: boolean;
}

export interface UpdateReviewDto {
  rating?: number;
  reviewerName?: string;
  comment?: string;
  highlights?: string[];
  wouldOrderAgain?: string;
  photoUrls?: string[];
  isEnabled?: boolean;
  adminNotes?: string;
}

export interface AdminCreateReviewDto {
  rating: number;
  reviewerName: string;
  comment?: string;
  photoUrls?: string[];
  highlights?: string[];
  wouldOrderAgain?: string;
  isEnabled: boolean;
  adminNotes?: string;
}

export interface ReviewDto {
  id: string;
  orderId: string;
  orderNumber: string;
  rating: number;
  reviewerName: string;
  comment?: string;
  photoUrls: string[];
  highlights: string[];
  wouldOrderAgain?: string;
  isEnabled: boolean;
  createdAt: string;
}

export interface PublicReviewDto {
  id: string;
  reviewerName: string;
  rating: number;
  comment?: string;
  photoUrls: string[];
  highlights: string[];
  wouldOrderAgain?: string;
  isVerified: boolean;
  createdAt: string;
}

export interface AdminReviewDto {
  id: string;
  orderId: string;
  orderNumber: string;
  userId: string;
  customerName: string;
  customerEmail: string;
  rating: number;
  reviewerName: string;
  comment?: string;
  photoUrls: string[];
  email?: string;
  highlights: string[];
  wouldOrderAgain?: string;
  isEnabled: boolean;
  isVerified: boolean;
  adminNotes?: string;
  createdAt: string;
  updatedAt?: string;
}

export interface ReviewStatisticsDto {
  totalReviews: number;
  enabledReviews: number;
  averageRating: number;
  ratingDistribution: Record<number, number>;
  highlightDistribution: Record<string, number>;
}

export interface CanReviewResponseDto {
  canReview: boolean;
  reason?: string;
  orderId?: string;
  orderNumber?: string;
  hasExistingReview?: boolean;
  existingReview?: ReviewDto;
}

export interface ReviewTokenValidationDto {
  isValid: boolean;
  orderId?: string;
  orderNumber?: string;
  customerName?: string;
  message?: string;
}

export interface PublicReviewFilterDto {
  pageNumber: number;
  pageSize: number;
  minRating?: number;
  sortBy?: string;
  sortDirection?: string;
}

export interface AdminReviewFilterDto {
  pageNumber: number;
  pageSize: number;
  rating?: number;
  isEnabled?: boolean;
  searchTerm?: string;
  fromDate?: string;
  toDate?: string;
  sortBy?: string;
  sortDirection?: string;
}

// Available highlight options for the review form
export const REVIEW_HIGHLIGHTS = [
  'Delivered as promised',
  'Same price as U.S. stores',
  'Easy ordering process',
  'Helpful support',
  'Secure & careful packaging'
] as const;

export type ReviewHighlight = typeof REVIEW_HIGHLIGHTS[number];

// Order again options
export const ORDER_AGAIN_OPTIONS = [
  'Yes',
  'Maybe',
  'No'
] as const;

export type OrderAgainOption = typeof ORDER_AGAIN_OPTIONS[number];
